<template>
  <div class="boxBody">
    <div class="bgc"></div>
    <div class="box">
      <div class="box_win">
        <div class="box_one">
          <h2>重庆小额贷款公司“十不准”</h2>
          <p>一、不准非法集资和吸收公众存款；</p>
          <p>二、不准发放利率超过司法部门规定上限的贷款；</p>
          <p>三、不准采取暴力、恐吓等手段非法收贷；</p>
          <p>四、不准抽逃注册资金；</p>
          <p>五、不准做虚假账务、报虚假信息和账外经营；</p>
          <p>六、不准违规跨经营区域发放贷款；</p>
          <p>七、不准开办未经监管部门批准的任何业务；</p>
          <p>八、不准超范围超比例投资；</p>
          <p>九、不准突破单户贷款比例；</p>
          <p>十、不准违规变更有关事项。</p>
        </div>
        <div class="shadow"></div>
        <div class="box_tow">
          <div class="box_tow_H">
            <h2>重庆小贷公司网贷业务“十不准”</h2>
            <p>一、不准在重庆市外办理线下自营贷款业务；</p>
            <p>二、不准通过网络平台在重庆市外办理委托贷款业务；</p>
            <p>三、不准通过网络平台在重庆市外办理股权投资类业务；</p>
            <p>四、不准通过网络平台为本公司融入资金；</p>
            <p>五、不准通过网络平台非法集资和吸收公众存款；</p>
            <p>六、不准通过网络平台销售、转让本公司的信贷资产和贷款债权;</p>
            <p>七、不准通过网络平台发放违反法律有关利率规定的贷款；</p>
            <p>八、不准隐瞒客户应知晓的本公司有关信息和擅自使用客户信息、非法买卖或泄露客户信息；</p>
            <p>九、不准在重庆市外的银行开立本公司的基本账户；</p>
            <p>十、不准在公司账外核算网络贷款的本金、利息和有关费用。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "forbid"
}
</script>

<style scoped lang="scss">
.boxBody {
  margin: 0;

  .bgc {
    width: 100%;
    height: 80vh;
    background: url("../../assets/十不准.jpg") center top no-repeat;
    background-size: 100% 135%;
  }

  .box {
    border-bottom: #e7e7e7 3px solid;

    .box_win {
      width: 90%;
      margin: 2% 5%;
      display: flex;

      .box_one {
        text-align: left;
        width: 45%;
      }

      .shadow {
        width: 2px;
        background-color: #81beff;
        box-shadow: 0px 0px 10px #81beff;
      }

      .box_tow {
        text-align: left;
        width: 55%;

        .box_tow_H {
          margin-left: 80px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Forbid/index.vue